import { render, staticRenderFns } from "./rate-add-or-update.vue?vue&type=template&id=1b65601e"
import script from "./rate-add-or-update.vue?vue&type=script&lang=js"
export * from "./rate-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports